export default "__VITE_ASSET__cbab7b12__"